export default __webpack_public_path__ + "static/media/certificate.f6d1fd5d.jpg";